import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Button, Row, Col, Typography, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { isMobileOnly } from 'react-device-detect';
import numeral from 'numeral';
import { LockOutlined, SafetyOutlined } from '@ant-design/icons';
const protectedPayment = require('../../../../assets/icons/protectedPayment.png');

import CheckOutComponent from '../../../ProductsImo/CheckOutComponent';
import env from '../../../../environment';
import _ from 'lodash';

const { Text } = Typography;

function ModalPayPending({ getDataOperation, setModalPay, modalPay, operationId, mortgage }) {
	const { t } = useTranslation();
	const [showCheckout, setShowCheckout] = useState(false);
	const [dataClient, setDataClient] = useState<any>('');
	const userToken = useSelector((state: any) => state.auth.token);

	useEffect(() => {
		getTokenPay();
	}, []);

	const getTokenPay = () => {
		axios
			.post(
				`${env.api.url}/v1/payments/appraisal/checkout`,
				{
					operationId: operationId
				},
				{
					headers: { Authorization: `Bearer ${userToken}` }
				}
			)
			.then((response) => {
				setDataClient(response.data.data);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<Modal
			className="ModalCommon"
			open={modalPay}
			footer={null}
			centered
			width={650}
			title={<Text>{t('payments.pending')}</Text>}
			onCancel={() => {
				setModalPay(!modalPay), setShowCheckout(!showCheckout);
			}}
			closable={true}>
			<div style={{ marginBottom: 0, marginTop: -40 }}>
				<Divider type="horizontal" style={{ color: '#D9D9D9' }}></Divider>
			</div>

			{showCheckout === false && (
				<>
					<Row>
						<Col span={15} style={{ display: 'flex', flexDirection: 'column' }}>
							<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 600 }}>
								{t('appraisal.payTitle')}
							</Text>
							<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
								{t('appraisal.payDes')}
							</Text>
						</Col>
						<Col span={9}>
							<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 600 }}>
								{numeral(Number(mortgage?.operationData?.mortgage?.appraisalAmount)).format(
									'0,0.00 $'
								)}
							</Text>
							<Button
								onClick={() => setShowCheckout(!showCheckout)}
								className="button-primari-gibobs"
								disabled={_.isNil(mortgage?.operationData?.mortgage?.appraisalAmount)}
								style={{ width: 80, height: 40, marginLeft: 24 }}>
								{t('appraisal.pay')}
							</Button>
						</Col>
					</Row>
				</>
			)}
			{showCheckout && mortgage && (
				<>
					<Row style={{ marginBottom: 24 }}>
						<Col span={16} style={{ display: 'flex', flexDirection: 'column' }}>
							<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 600 }}>
								{t('appraisal.payTitle')}
							</Text>
							<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 400 }}>
								{t('appraisal.payDes')}
							</Text>
						</Col>
						<Col span={8}>
							<Text style={{ color: '#748EA0', fontSize: 14, fontWeight: 600 }}>
								{numeral(Number(mortgage?.operationData?.mortgage?.appraisalAmount)).format(
									'0,0.00 $'
								)}
							</Text>
						</Col>
					</Row>

					<CheckOutComponent
						userMortgageId={operationId}
						amount={mortgage?.operationData?.mortgage?.appraisalAmount}
						showPayBoolean={showCheckout}
						mortgageId={operationId}
						clientSecretToken={dataClient?.paymentSeat?.session?.client_secret}
						dataClient={dataClient}
						firtsPaydocuments={true}
						setshowCheckout={setShowCheckout}
						setModalPay={setModalPay}
						getDataOperation={getDataOperation}
					/>
				</>
			)}
			<Row>
				<Divider type="horizontal" style={{ color: '#D9D9D9' }}></Divider>
			</Row>
			<Row style={{ display: 'flex', justifyContent: 'center' }}>
				<div>
					<LockOutlined style={{ color: '#748EA0', fontSize: 22 }} />
					<Text style={{ fontSize: 12, fontWeight: 400, color: '#748EA0', marginLeft: 8 }}>
						{t('doc.ourSecureInformation').replace(/:$/, '.')}
					</Text>
				</div>

				<div style={{ marginLeft: 24, display: 'flex', marginBottom: 40, marginTop: 2 }}>
					<div>
						<SafetyOutlined style={{ color: '#748EA0', fontSize: 22 }} />
					</div>
					<div>
						<Text
							style={{
								fontSize: 12,
								fontWeight: 400,
								color: '#748EA0',
								marginLeft: 8
							}}>
							{t('appraisal.protectedPayment')}
						</Text>
					</div>
				</div>
			</Row>
		</Modal>
	);
}

export default ModalPayPending;
